<template>
    <span class="currency_symbol" v-html="string">

    </span>
</template>

<script>
    export default {
        name: 'CurrencySymbol',
        props: {
            price: {
                type: Object,
                default: () => {
                    return {'price': 0, 'currency': 'RUB'}
                }
            },
            digits: {
                type: Number,
                default: () => {
                    return 0
                }
            }
        },
        computed:{
            string(){
                try {
                    let formatter = new Intl.NumberFormat('ru-RU', {
                        style: 'currency',
                        currency: this.price.currency,
                        minimumFractionDigits: this.digits
                    })

                    return formatter.format(this.price.value)
                }catch (e) {
                    return ''
                }
            }
        }
    }
</script>